import { motion } from "framer-motion";

const items = [
  "Tier-1 Life Insurer",
  "Pension Fund Manager",
  "Tier1 P&C Carrier",
  "Bancassurance Partner",
  "Reinsurance Provider",
  "Annuity Specialist",
  "Group Benefits Provider",
  "Microinsurance Network",
];

export const Clients = () => {
  const loop = [...items, ...items];
  return (
    <section id="insights" data-testid="clients-section" className="bg-ink text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="mb-5">
              <span className="overline text-copper">Our Clients</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Every client is a
              <br />
              valuable long-term partner.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-slate-300 leading-relaxed max-w-md">
              Most of our projects are complex and large — and we have
              consistently exceeded client expectations. Transparency, integrity
              of purpose and performance define how we operate.
            </p>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative border-y border-white/10 py-8">
        <div className="flex gap-12 md:gap-20 animate-marquee w-max">
          {loop.map((name, i) => (
            <div
              key={`${name}-${i}`}
              className="flex items-center gap-4 text-slate-300 hover:text-copper transition-colors"
              data-testid={`client-${i}`}
            >
              <span className="h-1.5 w-1.5 bg-copper" />
              <span className="font-display text-2xl md:text-3xl whitespace-nowrap tracking-tight">
                {name}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-ink to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-ink to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-8">
        {[
          ["Life", "100+ Products"],
          ["Pension", "Fund · DB · DC"],
          ["P&C", "Standalone or Full Core"],
          ["Group", "Portable Benefits"],
        ].map(([k, v], i) => (
          <motion.div
            key={k}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.6 }}
            className="border-t border-white/10 pt-6"
            data-testid={`segment-${i}`}
          >
            <div className="overline text-copper mb-3">Segment 0{i + 1}</div>
            <div className="font-display text-2xl">{k}</div>
            <div className="text-sm text-slate-400 mt-1">{v}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
